App.controller('ZochHealthPzuwDetailsCtrl', ['$scope', '$state', '$stateParams', '$timeout', 'Blob', 'FileSaver', 'zochaPzuwHealthInsuranceService',
    function ($scope, $state, $stateParams, $timeout, Blob, FileSaver, zochaPzuwHealthInsuranceService) {
        $scope.stateParams = $stateParams;

        $scope.page = 'zoch_healthInsurance';
        $scope.$emit('page', $scope.page);

        $scope.step = 'Szczegóły deklaracje';
        $scope.$emit('step', $scope.step);

        $scope.link = 'root.home.zoch.healthPzuw.list';
        $scope.$emit('link', $scope.link);

        $scope.data = $scope.stateParams.package;
        if (!$scope.data) {
            $state.go('root.home.zoch.healthPzuw.list');
            return;
        }

        if ($scope.data.partner && Object.keys($scope.data.partner).length) {
            $scope.partner_length = true;
        }

        if ($scope.data.children.length) {
            $scope.children_length = true;
        }

        if (typeof $scope.data.rehabilitation !== 'undefined' && $scope.data.rehabilitation) {
            $scope.data.benefit.workerPrice += $scope.data.benefit.rehabilitationPrice;
        }


        $scope.downloadDeclaration = function (ev, value) {
            let el = $(ev.currentTarget);
            if (el.hasClass('disabled')) {
                return 0;
            } else {
                $(ev.currentTarget).addClass('disabled');
            }

            let id = value.uuid, barcode = value.barcode;

            zochaPzuwHealthInsuranceService.downloadDeclaration(id).then(function (data) {
                if (data.status === 200) {
                    let blobData = new Blob([data.data], {type: 'application/pdf'});
                    FileSaver.saveAs(blobData, 'Deklaracja_' + barcode + '.pdf');
                }

                $timeout(function () {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });
        };

        $scope.downloadStatement = function (ev, data) {
            let el = $(ev.currentTarget);
            if (el.hasClass('disabled')) {
                return 0;
            } else {
                $(ev.currentTarget).addClass('disabled');
            }

            zochaPzuwHealthInsuranceService.downloadStatement(data.uuid).then(function (data) {
                if (data.status === 200) {
                    let blobData = new Blob([data.data], {type: 'application/pdf'});
                    FileSaver.saveAs(blobData, 'oswiadczenie.pdf');
                }

                $timeout(function () {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });
        };

        $scope.reason = 'EMPLOYEE_RESIGNATION';

        $scope.withdraw = function (id) {
            let criteria = {
                id: id,
                data: {
                    withdrawalReason: $scope.reason
                }
            };

            if ($scope.reason === 'DEATH') {
                criteria.data.dateOfDeath = $scope.dateOfDeath;
            }
            zochaHealthInsuranceService.withdraw(criteria).then(function (data) {
                if (data.status === 200) {
                    $state.go('root.home.zoch.healthPzuw.list');
                }
            });
        };

        // TODO PZUW support for change declaration
        $scope.redirectToDeclarationById = function (declaration) {
            let replacedBarcode = declaration.replacedByBarcode;
            let replacedDeclarationId = declaration.replacedByHealthInsuranceDeclarationId;
            if (!replacedBarcode || !replacedDeclarationId) {
                return;
            }

            let criteria = {
                pageNumber: 0,
                pageSize: 10,
                search: replacedBarcode
            };

            zochaHealthInsuranceService.dataList(criteria).then(function (data) {
                if (data.status === 200) {
                    let response = data.data.data;
                    if (response.length === 1) {
                        let _correctDeclaration = response[0];
                        _correctDeclaration.activeStatus = _correctDeclaration.status === 'ACTIVE';
                        if (_correctDeclaration.rehabilitation) {
                            _correctDeclaration.benefit.name += ' + Rehabilitacja';
                            _correctDeclaration.benefit.summaryPrice += _correctDeclaration.benefit.rehabilitationPrice;
                        }
                        if (_correctDeclaration.seniors.length > 0) {
                            _correctDeclaration.benefit.name += ' + Komfort Senior';
                            _correctDeclaration.benefit.summaryPrice += _correctDeclaration.seniors.length * _correctDeclaration.benefit.seniorPrice;
                        }
                        $state.go('root.home.zoch.healthPzuw.details', {package: _correctDeclaration});
                    } else {
                        for (let i = 0; i < response.length; i++) {
                            let _currentDeclaration = response[i];
                            if (_currentDeclaration.declaration.id === replacedDeclarationId) {
                                _currentDeclaration = _currentDeclaration === 'ACTIVE';
                                if (_currentDeclaration.rehabilitation) {
                                    _currentDeclaration.benefit.name += ' + Rehabilitacja';
                                    _currentDeclaration.benefit.summaryPrice += _currentDeclaration.benefit.rehabilitationPrice;
                                }
                                if (_currentDeclaration.seniors.length > 0) {
                                    _currentDeclaration.benefit.name += ' + Komfort Senior';
                                    _currentDeclaration.benefit.summaryPrice += _currentDeclaration.seniors.length * _currentDeclaration.benefit.seniorPrice;
                                }
                                $state.go('root.home.zoch.healthPzuw.details', {package: _currentDeclaration});
                            }
                        }
                    }
                }
            });
        };
    }
]);
